Object.defineProperty(exports, "__esModule", { value: true });
exports.compileObjectType = exports.compileObjectTypeWithConfig = exports.createTypeFieldsGetter = exports.compileOutputTypeCache = void 0;
const graphql_1 = require("graphql");
const ObjectType_1 = require("../ObjectType");
const Field_1 = require("../../field/Field");
const interfaceTypeRegistry_1 = require("../../interfaceType/interfaceTypeRegistry");
const cachedThunk_1 = require("../../../services/utils/cachedThunk");
const inheritance_1 = require("../../../services/utils/inheritance");
exports.compileOutputTypeCache = new WeakMap();
function createTypeFieldsGetter(target, config) {
    let targetWithParents = inheritance_1.getClassWithAllParentClasses(target);
    const { mixins } = config;
    if (mixins && Array.isArray(mixins)) {
        mixins.forEach((mixin, i) => {
            if (typeof mixin !== 'function') {
                throw new TypeError(`expected a mixin on ${target.name} to be a Class, instead value of index ${i} is ${mixin}`);
            }
        });
        targetWithParents = targetWithParents.concat(mixins);
    }
    if (config.implements) {
        config.implements.forEach((interfaceClass) => {
            if (typeof interfaceClass !== 'function') {
                throw new TypeError(`expected an "implements" reference on ${target.name} to be a Class, instead value is ${config.implements}`);
            }
        });
        targetWithParents = targetWithParents.concat(config.implements);
    }
    return cachedThunk_1.createCachedThunk(() => {
        if (typeof mixins === 'function') {
            targetWithParents = targetWithParents.concat(mixins());
        }
        return Field_1.compileAllFields(targetWithParents);
    });
}
exports.createTypeFieldsGetter = createTypeFieldsGetter;
function compileObjectTypeWithConfig(target, config) {
    if (exports.compileOutputTypeCache.has(target)) {
        return exports.compileOutputTypeCache.get(target);
    }
    let interfaces = null;
    if (config.implements) {
        interfaces = config.implements.map((interfaceClass) => {
            return interfaceTypeRegistry_1.interfaceTypeRegistry.get(interfaceClass);
        });
    }
    const compiled = new graphql_1.GraphQLObjectType({
        interfaces: interfaces
            ? cachedThunk_1.createCachedThunk(() => {
                return interfaces.map((intf) => intf());
            })
            : null,
        name: config.name,
        description: config.description,
        isTypeOf: (value) => value instanceof target,
        fields: createTypeFieldsGetter(target, config)
    });
    exports.compileOutputTypeCache.set(target, compiled);
    return compiled;
}
exports.compileObjectTypeWithConfig = compileObjectTypeWithConfig;
function compileObjectType(target) {
    if (!ObjectType_1.objectTypeRegistry.has(target)) {
        throw new ObjectType_1.ObjectTypeError(target, `Class is not registered. Make sure it's decorated with @ObjectType decorator`);
    }
    const compiler = ObjectType_1.objectTypeRegistry.get(target);
    return compiler();
}
exports.compileObjectType = compileObjectType;
//# sourceMappingURL=objectType.js.map